import { useEffect } from "react";
import "../assets/styles/component/header.css";
import { checkAuth } from "../services/api.service";
import Localization from "../contexts/Localization";

const Header = ({ navstate, setNavstate, title }) => {
  useEffect(() => {
    document.getElementsByClassName("logout-icon")[0].addEventListener("click", () => {
      localStorage.clear();
      window.location.replace("/login");
    });
    checkAuth();
    setInterval(() => {
      checkAuth();
    }, 60000);
  }, []);
  return (
    <div id="header">
      <div className="machine-info-cont">
        <i
          className={navstate ? "fa-solid fa-bars-staggered icon-show-nav" : "fa-solid fa-bars-staggered icon-show-nav icon-show-nav-opacity"}
          onClick={() => {
            setNavstate(!navstate ?? false);
            localStorage.setItem("nav-state", !navstate ?? false);
          }}
          role="switch"
        />
        <ul className="breadcrumb">
          <li className="transfer-machine">{title}</li>
        </ul>
      </div>
      <div className="logout-cont">
        <div className="bell-cont margin-icon-nav">
          <i className="fa-regular fa-bell"></i>
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <Localization />
        <i className="fa-solid fa-door-open margin-icon-nav logout-icon" title="Đăng xuất"></i>
      </div>
    </div>
  );
};

export default Header;
